/**
 * Module dependencies.
 */

import { Background, Image, Wrapper } from './catalog-header.style';
import { JSX } from 'react';

/**
 * Export `CatalogHeader` component.
 */

export function CatalogHeader(): JSX.Element {
  return (
    <>
      <Wrapper>
        <Background>
          <Image src={'/portfolio_bg.jpg'} />
        </Background>
      </Wrapper>
    </>
  );
}
